module.exports = __webpack_public_path__ + "img/7.10c8debf.png";